// @ts-nocheck
import { createContext, useContext } from 'react';

const TableColumnsContext = createContext();
const TableColumnsProvider = TableColumnsContext.Provider;
const TableColumnsConsumer = TableColumnsContext.Consumer;
const useTableColumns = () => useContext(TableColumnsContext);

export { TableColumnsProvider, TableColumnsConsumer, useTableColumns };
